<app-atom-model-counter
	[label]="'counter-label-formation-thematique' | translate"
	[customClass]="'counter-formation-thematique'"
	[loading]="loading"
	[count]="count"
	[iconTpl]="iconTpl"
	[linkFullList]="['/session/list']"
></app-atom-model-counter>

<ng-template #iconTpl>
	<i nz-icon nzType="audit" nzTheme="outline"></i>
</ng-template>
